import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-tooltip',
  templateUrl: './tooltip.component.html',
  styleUrls: ['./tooltip.component.scss']
})
export class TooltipComponent implements OnInit {
  arrayComponent: any;
  componentRender: any;
  infoComponent: any;
  codeHtml: string;
  utils: any;
  constructor() { 
    this.utils = window.utils;

    this.arrayComponent = [
      {
        id: 'tooltip',
        titulo: 'Componente',
        subtitulo: '',
        claseContainer: 'col-10',
        componentRender:
        `<a href="/" class="btn btn-round btn-high" data-toggle="tooltip" data-placement="top" title="Tooltip arriba">Tooltip arriba</a>
<a href="/" class="btn btn-round btn-high" data-toggle="tooltip" data-placement="right" title="Tooltip derecho">Tooltip derecho</a>
<a href="/" class="btn btn-round btn-high" data-toggle="tooltip" data-placement="left" title="Tooltip izquierdo">Tooltip izquierdo</a>
<a href="/" class="btn btn-round btn-high" data-toggle="tooltip" data-placement="bottom" title="Tooltip abajo">Tooltip abajo</a>
<a href="/" class="btn btn-round btn-high" data-toggle="tooltip"  data-html="true" title="<em>Tooltip</em> <u>with</u> <b>HTML</b>">Tooltip con HTML</a>
`,
        codejs: 
        `$(function () {
  $('[data-toggle="tooltip"]').tooltip();
});
 `
      },
    ],
    this.infoComponent = {
      titulo: "Tooltip",
      subtitulo: ""
    },
    this.codeHtml = `
    <script src="https://cdnjs.cloudflare.com/ajax/libs/popper.js/1.12.9/umd/popper.min.js" type="text/javascript"></script>`;

  }

  
  ngOnInit() {
  }
  ngAfterViewInit() {
    this.utils.tooltip();
  }

}








    
    